import { Feature, MultiPolygon, Polygon } from 'geojson';
import { DeclareMethod } from '/imports/methods';

// Three census-geography layers the Prospector draws over a site, each answering a different question
// about the tax credits and programme eligibility a project there could claim. Every one is read from
// its publisher at the moment it is asked for and none of it is stored — see server/integrations/arcgis.ts.

/** A layer's answer for one viewport, and whether the publisher had more than it would send at once. */
export interface ZoneLayer<T> {
  features: T[];
  truncated: boolean;
  /** a secondary source could not be read, so the features present are missing what it would have added */
  partial?: boolean;
}

/** HUD counts a tract as low-to-moderate income at 51% of its population or more. */
export const lmiThresholdPercent = 51;

export interface LmiZoneProperties {
  GEOID: string;
  STATE: string;
  COUNTY: string;
  TRACT: string;
  /** people in the tract who are low-to-moderate income */
  LOWMOD: number;
  /** the population that figure is drawn from */
  LOWMODUNIV: number;
  /** LOWMOD as a percentage of LOWMODUNIV */
  LOWMODPCT: number;
}
export type LmiZone = Feature<Polygon | MultiPolygon, LmiZoneProperties>;

export interface DacZoneProperties {
  GEOID10: string;
  /** state or territory */
  SF: string;
  /** county */
  CF: string;
  /** 1 where the tract is identified as disadvantaged */
  SN_C: number;
  /** identified through tribal overlap */
  SN_T: string;
  /** burden categories exceeded */
  CC: number;
  /** threshold criteria exceeded */
  TC: number;
  N_CLT: number;
  N_ENY: number;
  N_HLTH: number;
  N_HSG: number;
  N_PLN: number;
  N_TRN: number;
  N_WKFC: number;
  N_WTR: number;
}
export type DacZone = Feature<Polygon | MultiPolygon, DacZoneProperties>;

export interface MsaZoneProperties {
  msa_area_name: string;
  msa_nmsa_label: string;
  county_name_2020: string;
  state_name: string;
  /** 'Yes' where the area qualifies as an energy community */
  ec_qual_status: string;
  /** 'Yes' where it meets the fossil-fuel employment test */
  fee_qual_status: string;
}
export type MsaZone = Feature<Polygon | MultiPolygon, MsaZoneProperties>;

export const listLmiZonesInPolygon = DeclareMethod<{ polygon: Polygon }, ZoneLayer<LmiZone>>('listLmiZonesInPolygon');
export const listDacZonesInPolygon = DeclareMethod<{ polygon: Polygon }, ZoneLayer<DacZone>>('listDacZonesInPolygon');
export const listMsaZonesInPolygon = DeclareMethod<{ polygon: Polygon }, ZoneLayer<MsaZone>>('listMsaZonesInPolygon');
